'use client';

import React from 'react';
import { Link } from 'react-router-dom';
import appLogoDark from '../../assets/appLogoFinalDark.png';
import outlook from './Assets/outlookSafeSend.png'
import gmail1 from './Assets/gmail1.png'
import gmail2 from './Assets/gmail2.png'
import Header from './header';


export default function Whitelist() {
  return (
    <div className="min-h-screen bg-black text-white font-sans">
      <Header />

      {/* Main Content */}
      <main className="pt-24 pb-32 isolate">
        <div className="relative mx-auto max-w-4xl px-6 lg:px-8">
          {/* Header */}
          <div className="text-center mb-12 animate-fade-in">
            <h1 className="text-4xl font-semibold tracking-tight text-white sm:text-5xl">
              How to Whitelist an Email Address
            </h1>
            <p className="mt-6 text-lg text-gray-300 max-w-2xl mx-auto">
              Ensure emails from trusted sources reach your inbox by whitelisting them. Follow these steps for Outlook and Gmail.
            </p>
          </div>

          {/* Outlook Section */}
          <section className="mb-12 bg-stone-900 border border-stone-700 rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow duration-300 animate-fade-in">
            <h2 className="text-2xl font-semibold text-yellow-500 mb-4">Outlook</h2>
            <h3 className="text-lg font-medium text-white mb-3">Add to Safe Senders</h3>
            <p className="text-gray-300 mb-4">
              Add an email to your Safe Senders list to ensure it’s never marked as junk.
            </p>
            <ol className="list-decimal list-inside space-y-3 text-gray-300">
              <li>In the <strong>Home</strong> tab, click <strong>Junk</strong> in the ribbon.</li>
              <li>Select <strong>Junk E-mail Options</strong>.</li>
              <li>Go to the <strong>Safe Senders</strong> tab.</li>
              <li>Click <strong>Add</strong>, enter 'support@transtechconnect.com', then click <strong>OK</strong>.</li>
              <li>Close the dialog by clicking <strong>OK</strong>.</li>
            </ol>
            <div className="mt-6 flex justify-center">
              <img
                src={outlook}
                alt="Outlook Safe Senders interface"
                className="rounded-md shadow-md w-full max-w-md transform hover:scale-105 transition-transform duration-300"
              />
            </div>
          </section>

          {/* Gmail Section */}
          <section className="bg-stone-900 border border-stone-700 rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow duration-300 animate-fade-in">
            <h2 className="text-2xl font-semibold text-yellow-500 mb-4">Gmail</h2>
            <ol className="list-decimal list-inside space-y-3 text-gray-300">
              <li>Log in to Gmail on a desktop browser (mobile app doesn’t support this).</li>
              <li>Click the <strong>gear icon</strong> and select <strong>See all settings</strong>.</li>
              <li>Go to the <strong>Filters and Blocked Addresses</strong> tab.</li>
              <li>Click <strong>Create a new filter</strong>.</li>
              <li>In the <strong>From</strong> field, enter the email 'support@transtechconnect.com'.</li>
              <li>Click <strong>Create filter</strong>.</li>
              <li>Check <strong>Never send it to Spam</strong> and optionally <strong>Always mark it as important</strong>.</li>
              <li>Click <strong>Create filter</strong> to save.</li>
              <li>
                Alternatively, open a spam email and click <strong>Report not spam</strong> to whitelist it.
              </li>
            </ol>
            <div className="mt-6 flex flex-col sm:flex-row justify-center gap-4">
              <img
                src={gmail1}
                alt="Gmail Safe Send Step 1"
                className="rounded-md shadow-md w-full sm:w-1/2 max-w-md transform hover:scale-105 transition-transform duration-300"
              />
              <img
                src={gmail2}
                alt="Gmail Safe Send Step 2"
                className="rounded-md shadow-md w-full sm:w-1/2 max-w-md transform hover:scale-105 transition-transform duration-300"
              />
            </div>
          </section>
          <p className="mt-10 text-center text-gray-300 animate-slide-up">
            Whitelisting keeps important emails in your inbox. Need help? Contact your email provider’s support.
          </p>
        </div>
      </main>

      {/* Footer (Reused from Landing with your updated version) */}
      <footer className="relative mx-auto max-w-7xl px-6 lg:px-8 bg-stone-900 border-t border-stone-700/20">
        <div className="py-16 sm:py-24 lg:py-32">
          <div className="xl:grid xl:grid-cols-3 xl:gap-8">
            <span className="text-2xl font-bold text-yellow-500">TransTech Connect</span>
            <div className="mt-16 grid grid-cols-1 gap-8 xl:col-span-2 xl:mt-0">
              <div className="md:grid md:grid-cols-3 md:gap-8">
                <div>
                  <h3 className="text-sm/6 font-semibold text-white">Product</h3>
                  <ul role="list" className="mt-6 space-y-4">
                    <li>
                      <a
                        href="https://transtechsys.com/products/pqi380Plus"
                        target="_blank"
                        className="text-sm/6 text-gray-300 hover:text-yellow-500 transition duration-300"
                      >
                        PQI 380+
                      </a>
                    </li>
                  </ul>
                </div>
                <div>
                  <h3 className="text-sm/6 font-semibold text-white">Support</h3>
                  <ul role="list" className="mt-6 space-y-4">
                    <li>
                      <a
                        href="https://transtechsys.com/products/repairRequest"
                        target="_blank"
                        className="text-sm/6 text-gray-300 hover:text-yellow-500 transition duration-300"
                      >
                        Contact Support
                      </a>
                    </li>
                  </ul>
                </div>
                <div>
                  <h3 className="text-sm/6 font-semibold text-white">Sales</h3>
                  <ul role="list" className="mt-6 space-y-4">
                    <li>
                      <a
                        href="https://transtechsys.com/products/salesRequest"
                        target="_blank"
                        className="text-sm/6 text-gray-300 hover:text-yellow-500 transition duration-300"
                      >
                        Contact Sales
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://transtechsys.com/products/privacy"
                        target="_blank"
                        className="text-sm/6 text-gray-300 hover:text-yellow-500 transition duration-300"
                      >
                        Privacy Policy
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}